import { useRef, useState } from 'react'
import Lottie from 'lottie-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { images } from '../../constants';
import { timeline } from '../../data';
import './About.scss';
import timelineJSON from '../../assets/TimelineScroll.json';

const About = () => {
  const { t } = useTranslation();
  const [direction, setDirection] = useState(1);
  const [position, setPosition] = useState(0);
  const timelineRef = useRef(null);

  const handlePlayForward = () => {
    if (timelineRef.current) {
      timelineRef.current.setDirection(1);
      timelineRef.current.setSpeed(2.7);
      timelineRef.current.play();
    }
    setPosition(prevPosition => Math.min(prevPosition + 1, timeline.length - 1));
    setDirection(1);
  };

  const handlePlayReverse = () => {
    if (timelineRef.current) {
      timelineRef.current.setDirection(-1);
      timelineRef.current.setSpeed(2.7);
      timelineRef.current.goToAndStop(timelineRef.current.getDuration(true), true);
      timelineRef.current.play();
    }
    setPosition(prevPosition => Math.max(prevPosition - 1, 0));
    setDirection(-1);
  };

  const handleAnimationComplete = () => {
    timelineRef.current.goToAndStop(0);
  };

  // Get previous and next dates for the timeline display
  const prevDate = position > 0 ? t(`data.timeline.${position - 1}.date`) : '';
  const currentDate = t(`data.timeline.${position}.date`);
  const currentDesc = t(`data.timeline.${position}.description`);
  const nextDate = position < timeline.length - 1 ? t(`data.timeline.${position + 1}.date`) : '';

  return (
    <>
      <div className="aboutUs container section">
        <div id="About Us" />

        <div className="Hero__AboutsecB">
          <a className='Landingbtn' href="#About Us">
            <img src={images.arrowRight} alt="" />
          </a>
          <div className="Hero__head">
            <h1>{t('about.title')}</h1>
            <p>{t('about.description')}</p>
          </div>
          <div className="mvv__collection">
            <div className="mvv__solo">
              <img className="mvv__img" src={images.mission} alt="" />
              <img className="mvv__blur" src={images.bgBlur} alt="" />
              <h2>{t('about.mission')}</h2>
              <p>{t('about.missionText')}</p>
            </div>
            <div className="mvv__solo">
              <img className="mvv__img" src={images.vision} alt="" />
              <img className="mvv__blur" src={images.bgBlur} alt="" />
              <h2>{t('about.vision')}</h2>
              <p>{t('about.visionText')}</p>
            </div>
          </div>
        </div>

        <div className='Timeline__title'>
          <h1>{t('about.timelineTitle')}</h1>
          <p>{t('about.timelineSubtitle')}</p>
        </div>

        <div className="aboutUs__timeline">
          <div className='Timeline__content'>
            <button
              onClick={handlePlayReverse}
              disabled={position === 0}>
              <img
                className={`timeline__up ${position === 0 ? 'disabled' : ''}`}
                src={images.arrowRight}
                alt="Previous" />
            </button>

            <AnimatePresence custom={direction} mode='wait'>
              <motion.div
                initial={{ opacity: 0, x: direction > 0 ? -50 : 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: direction > 0 ? 50 : -50 }}
                transition={{ duration: 0.25 }}
                key={position}
                className='timeline__desc'>

                <div className='timeline__date'>
                  <h3>{prevDate}</h3>
                  <h2>{currentDate}</h2>
                  <h3>{nextDate}</h3>
                </div>
                <div className="timeline__Vid">
                  <Lottie
                    lottieRef={timelineRef}
                    autoplay={false}
                    loop={false}
                    animationData={timelineJSON}
                    onComplete={handleAnimationComplete}
                  />
                </div>
                <div className='timeline__info'>
                  <h3>{currentDate}</h3>
                  <h4>{currentDesc}</h4>
                </div>
              </motion.div>
            </AnimatePresence>

            <button
              onClick={handlePlayForward}
              disabled={position === timeline.length - 1}>
              <img
                className={`timeline__down ${position === timeline.length - 1 ? 'disabled' : ''}`}
                src={images.arrowLeft}
                alt="Next" />
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default About;
